export const worldWide = [
    {name: "cl", value: "cl", flag: "cl", text: "Rut"},
    {name: "other", value: "other", flag: "eu", text: "Otro"},
]